// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const AppShellContract = contract({
  name: "AppShell",
  description: "The top-level page scaffold for any app-like or marketing layout. Reach for AppShell\ninstead of hand-rolling `grid grid-cols-[auto_1fr]` so the layout shape (top nav,\nside nav, three-pane Slack/Mail/Notion shape, constrained vs full-width main) is a\nprop the settings panel can mutate. Don't compose top-level layouts from raw grid\ntemplates — the four variants below cover most app shapes.\n\nPick the `nav` variant from the source:\n  nav=\"none\"        — Single column. Marketing landing, login, splash.\n  nav=\"top\"         — Top bar + content. Reddit, Twitter chrome.\n  nav=\"side\"        — Left nav + content. Linear, Notion sidebar shape.\n  nav=\"three-pane\"  — **Narrow icon rail + Aside + Main.** The Slack /\n                      WhatsApp / Mail / Plane / Discord / Notion-with-pages\n                      shape. ANY time you see a vertical icon rail next to\n                      a separate list/sidebar, this is the answer — don't\n                      reach for raw `<div className=\"grid\">` with three\n                      column tracks.",
  import: "@gradeui/ui",
  subcomponents: ["AppShellHeader","AppShellNav","AppShellAside","AppShellMain","AppShellFooter"],
  composesWith: ["Stack","Row","Card","Button","Separator","Sidebar","Toolbar","any page content"],
  styleDefaults: {"AppShell":"gds-app-shell min-h-screen w-full bg-background text-foreground grid","AppShellHeader":"gds-app-shell-header","AppShellNav":"gds-app-shell-nav border-b bg-background","AppShellAside":"gds-app-shell-aside min-w-0 border-r bg-background","AppShellMain":"gds-app-shell-main min-w-0 w-full","AppShellFooter":"gds-app-shell-footer border-t bg-background"},
  variantDefaults: {"nav":"none"},
  props: {
  "nav": {
      schema: z.enum(["none", "top", "side", "three-pane"]).optional(),
      design: "knob",
      description: "layout structure",
      default: "none",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "render as the child element via Slot",
      default: false,
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  "children": {
      schema: z.unknown(),
      design: "plumbing",
  },
  },
});
